<template>
    <div class="agreeWrap">
       <div class="container-bd">
        <div class="c-left">
          <h3 class="page-title page-title-split">{{appname}}隐私政策</h3>
          <div class="mod mod-base news">
            <div class="bd">
              <p>
                以下为隐私政策正文，我们建议您认真、完整地阅读本隐私政策。
              </p>
              <h4>一、以下为隐私政策正文，我们建议您认真、完整地阅读本隐私政策。</h4>
              <ol class="list decimal-list">
                <li>
                  1.1 保护用户个人信息是的一项基本原则。我们致力于提升信息处理透明度，增强您对信息管理的便捷性，保障您的信息及通信安全。严格遵守法律法规，遵循以下隐私保护原则，为您提供更加安全、可靠的服务：
                  <ul class="list">
                    <li>
                      （1）安全可靠：我们竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失；
                    </li>
                    <li>
                      （2）保护通信秘密：我们严格遵照法律法规，保护您的通信秘密，为您提供安全的通信服务；
                    </li>
                    <li>
                      （3）合理必要：为了向您和其他用户提供更好的服务，我們仅收集必要的信息；
                    </li>
                    <li>
                      （4）清晰透明：我们努力使用简明易懂的表述，向您介绍隐私政策，以便您清晰地了解我们的信息处理方式；
                    </li>
                  </ul>
                </li>
                <li>
                  1.2 您在注册账号或使用本服务的过程中，可能需要填写一些必要的信息（详见第二点，我们可能会收集的信息）。。一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。当我们的产品或服务发生停止运营的情形时，我们将采取通知或公告的形式通知您，并在合理的期限内刪除或匿名化处理您的个人信息；
                </li>
                <li>
                  1.3 一般情況下，您可随时浏览、修改自己提交的信息，但出于安全性和身份辨别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。
                </li>
                <li>
                  1.4 我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您的家长或法定监护人的同意。 若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过网站中的联系方式与我们联系。
                </li>
                <li>
                  1.5 未经您的同意，我们不会向{{appname}}以外的任何公司、组织和个人披露您的个人信息，保证不对外公开或向第三方披露或提供用户注册资料及用户在使用网络服务时存储在本软件、服务器或数据库的非公开内容和信息，但下列情況除外：
                  <ul class="list">
                    <li>（1）事先获得用户的明确授权；</li>
                    <li>（2）根据有关的法律法规要求；</li>
                    <li>
                      （3）按照相关政府主管部门和司法机关的要求；
                    </li>
                    <li>
                      （4）为维护社会公众的利益；
                    </li>
                    <li>
                      （5）为执行相关服务协议或为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
                    </li>
                  </ul>
                </li>
                <li>
                  1.6 因用户使用第三方服务或者设备，可能导致用户信息通过其他方式透露给第三方，用户需自行了解第三方对用户信息保护的相关条款，{{appname}}不承担由此产生的风险。上述情形包括：用户在移动设备上使用第三方应用程序；因第三方应用程序收集的用户信息可能发送至第三方进行处理。
                </li>
              </ol>
              <h4>二、【个人信息收集的范围与方式】</h4>
              <p>
                我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。我们可能会收集、储存和使用下列与您有关的信息。对本协议的同意将被视为同意我们收集您的个人信息，并在法律规定及本协议约定的范围内进行使用。
              </p>
              <ol class="list decimal-list">
                <li>
                  2.1 我们收集以下各类信息：
                  <ul class="textIndet10">
                    <li>
                      2.1.1 账号服务所需信息：
                      <ul class="list textIndet20">
                        <li>
                          （1） 您在注册账户时填写的信息：手机号码*/电子邮箱地址*、密码*；
                        </li>
                        <li>
                          （2） 我们可能会获得您在使用第三方合作伙伴的账号（Facebook、Google）登录时，第三方向我们披露的信息，包括：用户名、头像。用于与本软件账号绑定，使您可以直接登录并使用本软件。对于这部分内容，请您仔细阅读第三方合作伙伴服务的用户协议或隐私政策；
                        </li>
                        <li>
                          （3） 您在编辑资料时填写/选择的信息：头像、昵称；
                        </li>
                        <li>
                          （4） 个人账户资料显示：头像、昵称、应用内虚拟币余额*、已订作品数量；
                        </li>
                        <li>
                          （5） 账户安全：我们需要收集您的一些信息来保障您的账号安全、判断您的账户及交易风险，包括如下信息：手机厂商、系统版本、系统语言、产品版本号、交易信息*；一旦我们检测出存在或疑似存在账号安全风险时，我们会使用相关信息进行安全验证与风险排除，确保我们向您提供的产品和服务的安全性，以用来保障您的权益不受侵害。
                        </li>
                      </ul>
                    </li>
                    <li>
                      2.1.2 产品或服务所需信息
                      <ul class="list textIndet20">
                        <li>
                          （1） 文字阅读功能：为了能够更好的為为您提供小说阅读服务，提升阅读体验、优化小说展示效果，我们需要收集如下信息：设备型号、设备品牌、设备唯一标识符、操作系统和应用程序版本及来源渠道、网络类型、日志信息*（操作日志、服务日志、开发日志、闪退日志）；
                        </li>
                        <li>
                          （2） 搜索功能：当您使用搜索功能时，我们需要收集您搜索的字词、浏览记录，以提供给您更好的搜索结果、同时改进我们的产品服务；
                        </li>
                        <li>
                          （3） 评论信息发布功能：当您使用评论功能时，我们将收集您主动提供的图文信息；
                        </li>
                        <li>
                          （4） 客服/用户反馈功能：当您通过客服进行咨询、账号申诉功能时，我们可能需要收集您的账号信息以验证您的身份，也有可能收集您反馈意见和建议时填写的手机号码*、邮箱；
                        </li>
                        <li>
                          * 我们的部分服务可能需要您提供特定的个人敏感信息（本隐私政策中标註*）来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息；
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  2.2 根据用户行为及产品特点，我们可能访问用户手机上的以下内容：
                  <ul class="textIndet10">
                    <li>
                      2.2.1 对于使用{{appname}}的用户，您在使用我们向您提供的相关产品时，为提供、处理、维护、改善、开发我们的商品和/或提供给您的服务之目的，该产品可能获取您终端设备的如下权限：
                      <ul class="textIndet20">
                        <li>
                          （1）用户下载图书时，因需将图书数据存入SD卡内而写入/删除内部存储；
                        </li>
                        <li>
                          （2）用户阅读已下载图书时，因需读取图书数据而读取内部存储；
                        </li>
                        <li>
                          （3）为确认下载图书数据存放方式需判断用户是否插入SD卡而使用挂载文件系统权限；
                        </li>
                        <li>
                          （4）为计算存储空间的空闲区域而使用获取应用大小权限；
                        </li>
                        <li>
                          （5）为使用本软件联网功能而使用访问网络权限；
                        </li>
                        <li>
                          （6）为判断用户当前网络状态以便提示用户而获取用户网络状态；
                        </li>
                        <li>
                          （7）提示用户打开网络而使用改变网络状态权限；
                        </li>
                        <li>
                          （8）用户进行下载图书操作时，当用户当前网络是2G/3G/4G时，为节约用户流量提示其打开wifi网络而使用获取、改变wifi状态权限；
                        </li>
                        <li>
                          （9）为用户调节手机亮度而读写系统设置项；
                        </li>
                        <li>
                          （10）为保证用户在阅读的图书更新时能第一时间获得通知而允许程序开机自动运行、允许程序在手机屏幕关闭后后臺进程仍然运行；
                        </li>
                        <li>
                          （11）为发生异常情况时重啟本软件而使用结束系统任务权限；
                        </li>
                        <li>
                          （12）为在手机桌面创建快捷方式而使用排序系统任务；
                        </li>
                        <li>
                          （13）为在Android 7.1系统及以上实现ShortCut快捷方式功能，需要创建桌面快捷方式权限；
                        </li>
                        <li>
                          （14）为给用户手机发送图书更新通知时手机震动而使用允许振动权限；
                        </li>
                        <li>
                          （15）为帮助用户解决本软件发生异常时的问题而读取系统日誌；
                        </li>
                        <li>
                          （16）为监测用户将图书分享到其他应用功能是否正常而使用允许程序获取当前或最近运行的应用权限；
                        </li>
                        <li>
                          （17）为实现悬浮窗功能而使用显示系统窗口权限；
                        </li>
                        <li>
                          （18）为使用户在全屏阅读时，阅读页面显示电池电量信息而使用电池状态权限；
                        </li>
                        <li>
                          （19）当用户在设置阅读界面常亮，需要使用保持屏幕常亮权限，使系统不会因為用户长时间不操作而关闭屏幕；
                        </li>
                        <li>
                          （20）为了允许应用出现闪退后清楚本身进程重启，需要杀死后台进程功能；
                        </li>
                      </ul>
                    </li>
                    <li>
                      2.2.2 第三方SDK接入服务所需开通的权限
                      <p>
                        我们的产品和服务可能包括第三方的产品和服务，以及第三方网站的链接。当您使用这些产品或服务时，也可能收集您的信息。在第三方向您提供产品和服务时，可能会获取到以下权限：
                      </p>
                      <ul class="textIndet20">
                        <li>
                          （1）友盟移动数据统计SDK需通过用户当前的位置*来进行相关决策，需获取粗略位置*及位置*权限；
                        </li>
                        <li>
                          （2）为接受阿里云发来的消息，需获取阿里云推送权限；
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ol>
              <h4>三、【个人信息的使用方式】</h4>
              <ol class="list decimal-list">
                <li>
                  3.1 我们可能如何使用信息
                  <ul class="textIndet10">
                    <li>
                      3.1.1用户同意我们基于下列原因需要使用用户的信息资源：
                      <ul class="textIndet20">
                        <li>
                          （1）向您提供核心阅读服务；
                        </li>
                        <li>
                          （2）安全保障。我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务中；
                        </li>
                        <li>
                          （3）产品的开发和优化。当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务；
                        </li>
                        <li>
                          （4）使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，包括个性化推荐书籍、个性化推送；
                        </li>
                        <li>
                          （5）执行软件，进行软件认证或软件升级；
                        </li>
                        <li>
                          （6）让您参与有关我们产品和服务的调查；
                        </li>
                        <li>
                          （7）向您推荐您可能感兴趣的广告、资讯、评估，进一步改善我们的广告投放和其他促销及推广活动的效果；
                        </li>
                        <li>
                          （8）在用户同意的情况下，将根据用户信息所作出的统计数据、行为分析非关联用户身份识别的信息提供给合作单位，用于呈现合作效果；
                        </li>
                        <li>
                          （9）为用户推送通知及{{appname}}提供的服务信息；
                        </li>
                        <li>
                          （10）修改全局系统设置；更改屏幕显示方向；使用模拟地点来源进行测试；编辑短信或彩信。
                        </li>
                      </ul>
                    </li>
                    <li>
                      3.1.2涉及个人信息使用的功能列表：
                      <ul class="textIndet20">
                        <li>
                          （1） 基础的账号服务：使用您的手机号码、您使用的昵称及密码用户创建账号，继而使用需要平台账号才能开通的服务：评论、分享、签到、点赞、投守护票、送红包、参加活动，展示用户获得的公开荣誉；
                        </li>
                        <li>
                          （2） 当用户参与站内举办的活动时，我们需要用户的个人信息：昵称/头像用于抽奖结果、粉丝排行榜及其他公示内容的展示。
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  3.2 为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息用於我们的其他服务。在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。
                </li>
                <li>
                  3.3 为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，您使用应用程序的频率、故障信息、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。
                </li>
                <li>
                  3.4 在您使用我们的产品或服务时，我们可能通过放置安全的Cookie及相关技术收集您的信息，包括：您的登录信息、浏览信息、偏好设置。您也可以通过浏览器设置管理Cookie。但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。Cookie 对提升用户的网络使用体验十分重要，我们使用Cookie一般出于以下目的：
                  <ul class="textIndet10">
                    <li>
                      （1）优化登录体验： Cookie可以在您进行注册、登录时，通过存储账号信息，帮您填入您最后登入的账号名称、简化您重复操作的步骤；
                    </li>
                    <li>
                      （2）安全：Cookie可帮助我们保障数据和服务的安全性，排查针对我们的产品和服务的作弊、黑客、欺诈行为；
                    </li>
                  </ul>
                </li>
                <li>
                  3.5 信息的分享和披露
                  <ul class="textIndet10">
                    <li>
                      3.5.1 在法律法规规定的情况下，或经您事先明确同意或手动选择，我们可能与第三方分享您的个人信息；
                    </li>
                    <li>
                      3.5.2 仅为实现外部处理的目的，我们可能会与第三方合作伙伴（第三方服务供应商、承包商、代理、广告合作伙伴、应用开发者，代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置*服务的地图服务供应商）（他们可能并非位于您所在的法域）分享您的个人信息，让他们按照我们的说明、隐私协议以及其他相关的保密和安全措施来为我们处理上述信息，如我们与上述第三方分享您的信息，我们将会采用加密、匿名化处理等手段保障您的信息安全，并用于以下用途：
                      <ul class="textIndet20">
                        <li>
                          （1）向您提供我们的服务；
                        </li>
                        <li>
                          （2）实现"我们如何使用收集的信息"部分所述目的；
                        </li>
                        <li>
                          （3）履行我们在《用户服务协议》中的义务和行使我们的权利；
                        </li>
                        <li>
                          （4）理解、维护和改善我们的服务。
                        </li>
                      </ul>
                      如我们与上述第三方分享您的信息，我们将会采用加密、匿名化处理手段保障您的信息安全。
                    </li>
                    <li>
                      3.5.3信息的转让
                    </li>
                    <li>
                      我们不会对{{appname}}以外的公司、组织个人转让用户的个人信息，但以下情况除外:
                      <ul class="textIndet20">
                        <li>
                          （1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
                        </li>
                        <li>
                          （2）随著我们业务的持续发展，当发生合并、收购、资产转让交易导致向第三方分享您的个人信息时，我们将通过推送通知、公告形式告知您相关情形，按照法律法规及不低于本协议所要求的标准继续保护或要求新的管理者继续保护您的个人信息。
                        </li>
                      </ul>
                    </li>
                    <li>
                      3.5.4 我们会将所收集到的信息用于大数据分析。我们将收集到的信息用于分析形成不包含任何个人信息的行业洞察报告。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。
                    </li>
                    <li>
                      3.5.5 我们可能基于以下目的披露您的个人信息：
                      <ul class="textIndet20">
                        <li>
                          （1）遵守适用的法律法规等有关规定；
                        </li>
                        <li>
                          （2）遵守法院判决、裁定或其他法律程序的规定；
                        </li>
                        <li>
                          （3）遵守相关政府机关或其他法定授权组织的要求；
                        </li>
                        <li>
                          （4）我们有理由确信需要遵守法律法规等有关规定；
                        </li>
                        <li>
                          （5）为执行相关服务协议或本协议、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财產安全或其他合法权益合理且必要的用途。
                        </li>
                      </ul>
                    </li>
                    <li>
                      3.5.6 共享、转让、公开披露个人信息涉及类型
                      <ul class="textIndet20">
                        <li>
                          （1）网页对外共享、转让、公开披露的个人信息的类型：设备号、网络地域、充值/消费金额*、阅读书籍、发表评论/想法、书籍评分、创建的书单、读过书籍数量、关注作者/用户、收藏书籍/专题/书单；
                        </li>
                        <ul>
                          （2）App对外共享、转让、公开披露的个人信息的类型：广告服务加密提供通过该渠道下载用户设备号、渠道、版本、平台、阅读时长、阅读书籍分类、付费金额*。
                        </ul>
                      </ul>
                    </li>
                    <li>
                      3.5.7 我们已知晓对外共享、转让、公开披露个人信息所承担的相应法律责任，并将采取合理措施保障个人信息安全。
                    </li>
                  </ul>
                </li>
              </ol>
              <h4>四、【知识产权】</h4>
              <ul>
                <li>
                  4.1 {{appname}}的一切知识产权，以及与{{appname}}相关的所有信息内容，包括但不限于文字表述及其组合、图标、图饰、图像、图表、色彩、界面设计、版面框架、有关数据、附加程序、印刷材料或电子文档等均为{{appname}}所有，受著作权法和国际著作权条约以及其他知识产权法律法规的保护。
                </li>
                <li>
                  4.2 未经{{appname}}书面同意，用户不得以任何营利性或非营利性的目的自行实施、利用、转让或许可任何第三方实施、利用、转让上述知识产权，{{appname}}保留追究上述未经许可行为的权利。
                </li>
                <li>
                  4.3 禁止反向工程、反向编译和反向汇编：用户不得对本软件产品进行反向工程（Reverse Engineer）、反向编译（Decompile）或反向汇编（Disassemble），同时不得改动编译在程序文件内部的任何资源。除法律、法规明文规定允许上述活动外，用户必须遵守此协议限制。
                </li>
                <li>
                  4.4 组件分割：本软件产品是作为一个整体产品而被授予许可使用,用户不得将各个部分分开用于任何目的。
                </li>
                <li>
                  4.5 个别授权：如需进行商业性的销售、复制、分发，包括但不限于软件销售、预装、捆绑等，必须获得{{appname}}的书面授权和许可。
                </li>
                <li>
                  4.6 保留权利：本协议未明示授权的其他一切权利仍归{{appname}}所有，用户使用其他权利时必须获得海文小说的书面同意。
                </li>
                <li>
                  4.7 {{appname}}提供的书籍内容仅代表作者自己的立场和观点，与{{appname}}无关，由作者本人承担一切法律责任。
                </li>
              </ul>
              <h4>五、您的权利</h4>
              <p class="mt10">
                按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
              </p>
              <ul>
                <li>
                  5.1 查询、复制、或更正、补充您的个人信息
                </li>
                <p class="mt10">
                  当您完成账号注册并进行合理和必要的身份验证后，您可以随时登录自己的账号查看、复制或修改账号设置和信息。如果您发现信息有错误、不准确或不完整的，您可以登录账号，在您的账号设置中修改您的账号信息以更正、补充或者通过本政策列明的联系方式提出异议并请求我们进行更正、补充，除非法律法规另有规定。
                </p>
                <p class="mt10">
                  如您希望查看、复制或修改您的其他个人信息，或在行使上述权利过程中遇到困难，您可以通过本政策列明的联系方式联系我们，我们将在15个工作日内完成核查和处理，但法律法规另有规定的或本政策声明另有约定的除外。
                </p>
                <li>
                  5.2 删除您的个人信息
                  <p class="mt10">在以下情形中，您可以向我们提出删除个人信息的请求：</p>
                  <ul class="list">
                    <li>
                      （1）如果我们处理个人信息的行为违反法律法规；
                    </li>
                    <li>
                      （2）如果我们收集、使用您的个人信息，却未征得您的同意；
                    </li>
                    <li>
                      （3）如果我们处理个人信息的行为违反了与您的约定
                    </li>
                    <li>
                      （4）如果您不再使用我们的产品或服务，或您注销了帐号；
                    </li>
                    <li>
                      （5）如果我们不再为您提供产品或服务。
                    </li>
                  </ul>
                  <p class="mt10">
                    如您希望删除您的其他个人信息，或在行使上述权利过程中遇到困难，您可以通过本政策列明的方式联系我们，我们将在15个工作日内完成核查和处理，但法律法规另有规定的或本政策声明另有约定的除外。
                  </p>
                  <p class="mt10">
                    请注意，法律、行政法规或其他规范性文件规定的保存期限尚未届满，或者删除个人信息从技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理，直到可以删除或实现匿名化。
                  </p>
                </li>
                <li>
                  5.3 注销您的账户
                  <p class="mt10">
                    您随时可注销此前注册的帐户，但您应当向本站网络提供帐号相应的注册信息，具体流程可咨询客服。
                  </p>
                  <p class="mt10">
                    在注销账户之后，我们将停止为您提供产品或服务，并依据法律法规相关要求通过匿名化等方式处理您的个人信息，或删除与您账号相关的个人信息，但法律法规或监管机构对用户信息存储时间另有规定的除外。
                  </p>
                </li>
                <li>
                  5.4 改变您授权同意的范围或撤销您的授权同意
                  <p class="mt10">
                    请您理解，每个业务功能往往需要开启部分权限并收集必要的个人信息才能得以实现，对于您个人信息的收集、使用以及设备权限的管理。您可以通过在我们具体产品/服务中删除信息、 更改隐私设置以及在浏览器或操作系统中关闭设备功能等方式改变同意范围或撤回您的授权。
                  </p>
                  <p class="mt10">
                    您可以通过您的手机系统权限撤回您授予的设备权限，您也可以通过该路径开启相关设备权限。
                  </p>
                  <p class="mt10">
                    请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权而开展的个人信息处理。
                  </p>
                  <P class="mt10">
                    如果您希望更改或撤回其他已经您授权的同意，您可以通过产品实际界面提供的撤销方式或本政策列明的联系方式与我们取得联系并行使您的相关权利。
                  </P>
                  <p class="mt10">
                    如果该等授权同意并非使用服务所必需，您可以通过我们的客服与我们联系，对部分个人信息改变或撤销您的授权同意。我们会在15个工作日内答复您的请求。
                  </p>
                  <p class="mt10">
                    当您撤销授权同意后，我们将不再处理相应的个人信息。但您撤销授权同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
                  </p>
                </li>
                <li>
                  5.5 响应您的上述请求
                  <p class="mt10">
                    为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
                  </p>
                  <p class="mt10">
                    对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取壹定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、 给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ol class="list decimal-list footer-text">
          <li>kefu@heiyan.com</li>
          <li>Copyright © 2023</li>
          <li>{{appname}}</li>
        </ol>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
        flag: 'zh_CN ',
        appname: '黑岩故事会'
      }
    },
    onLoad () {
    
    }
  };
  </script>
  
  <style lang="stylus" scoped>
  .agreeWrap{
      font-size:  16px;
      padding: 15px;
      line-height: 20px;
      min-height 100vh;
      height auto;
      background: #fff;
      h1{
          font-size: 18px
      }
          h6,h4{
              padding: 15px 0;
              font-size: 16px;
              line-height: 20px
          }
          li{
              margin:  10px 0;
          }
      }
      .textIndet10{
          text-indent: 10px;
      }
      .textIndet20{
          text-indent: 15px;
      }
      .footer-text{
        text-align:right;
        padding-right:50px;
      }
  </style>
  